import { timeline } from "@/mocks/blackdata";

export default function Timeline() {
  return (
    <section id="timeline" className="max-w-[1400px] mx-auto px-3 md:px-6 pt-10 md:pt-14 scroll-mt-20">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 pb-5">
        <div>
          <span className="inline-flex items-center gap-1 rounded bg-accent-500 text-background-50 px-2 py-0.5 text-[11px] whitespace-nowrap">
            <i className="ri-history-fill w-3.5 h-3.5 flex items-center justify-center"></i>
            王野直播 · 事件时间线
          </span>
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mt-2">按人物梳理争议往事</h2>
          <p className="text-[13px] md:text-sm text-foreground-600 mt-1">
            48 小时反转按节点归档，每条都标注阶段标签，吃瓜不落一环、不漏一屏。
          </p>
        </div>
        <div className="flex items-center gap-2 text-[12px] text-foreground-500">
          <span className="inline-flex items-center gap-1"><i className="ri-history-line w-4 h-4 flex items-center justify-center text-accent-600"></i>自动同步事件进展</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3 md:gap-4">
        {timeline.map((t, i) => (
          <div key={t.title} className="relative flex sm:flex-col gap-3 sm:gap-0 bg-background-100 border border-background-200 rounded-lg p-4">
            {/* connecting top line for lg */}
            {i < timeline.length - 1 && (
              <span className="hidden lg:block absolute top-[34px] left-[calc(50%+16px)] w-[calc(100%-32px)] h-px bg-background-200"></span>
            )}
            <div className="flex sm:flex-col sm:items-start gap-2 shrink-0">
              <span className={`relative z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[12px] font-bold text-background-50 ${
                i === timeline.length - 1 ? "bg-primary-600" : "bg-foreground-800"
              }`}>
                {i + 1}
              </span>
            </div>
            <div className="flex flex-col gap-1.5 pt-0 sm:pt-2">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                <span className="font-heading text-sm text-foreground-900">{t.when}</span>
                <span className={`rounded px-1.5 py-0.5 text-[10px] whitespace-nowrap ${
                  i === timeline.length - 1 ? "bg-primary-100 text-primary-800" : "bg-background-200 text-foreground-600"
                }`}>{t.tag}</span>
              </div>
              <h3 className="text-[14px] font-semibold text-foreground-950 leading-snug">{t.title}</h3>
              <p className="text-[12px] text-foreground-600 leading-relaxed">{t.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}